// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Hor5","content":"styles_content__LE3-W","tableWrap":"styles_tableWrap__107hq"};